module.exports = __webpack_public_path__ + "static/media/default-image.5eef1725.jpg";